import { useQuery } from "@tanstack/react-query";
import { useCosmosApi } from "@/lib/api/useCosmosApi";

export type OpenApiDocument = {
	openapi: string;
	info: {
		title: string;
		version: string;
		description?: string;
	};
	servers?: Array<{ url: string; description?: string }>;
	paths: Record<string, unknown>;
	components?: Record<string, unknown>;
	tags?: Array<{ name: string; description?: string }>;
};

export function useOpenApiSpec() {
	const request = useCosmosApi();

	return useQuery({
		queryKey: ["cosmos-openapi-spec"],
		queryFn: () => request<OpenApiDocument>("/api/spec/openapi"),
		staleTime: 5 * 60 * 1000
	});
}
